import Box from '@/common/components/Box'
import BoxWithHeader from '@/common/components/BoxWithHeader'
import Skeleton from '@/common/components/Skeleton'

const MaintenanceWorkflowFiscalAssessmentEntryUpdateLoading = () => {
  return (
    <div className="flex-1 flex gap-6">
      <div className="flex-1">
        <Box className="p-4 flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Skeleton className="w-32 h-5" />
            <Skeleton className="h-24 rounded-lg" />
          </div>

          <div className="h-px bg-white-200" />

          <div className="flex flex-col gap-2">
            <Skeleton className="w-32 h-5" />
            <Skeleton className="h-24 rounded-lg" />
          </div>
        </Box>
      </div>

      <div>
        <BoxWithHeader title="Checklist" subtitle="">
          <div className="flex flex-col gap-2">
            <Skeleton className="w-48 h-5" />
            <Skeleton className="w-48 h-5" />
            <Skeleton className="w-48 h-5" />
          </div>
        </BoxWithHeader>
      </div>
    </div>
  )
}

export default MaintenanceWorkflowFiscalAssessmentEntryUpdateLoading
